import cloneDeep from 'lodash.clonedeep';
import { createSelector } from 'reselect';
import { RootState } from 'data/root.reducers';
import { TargetModel } from 'data/target/target.types';
import { CaseModel } from './case.types';
import { getTargetsById } from '../target/target.selectors';

export const getCases = (state: RootState): CaseModel[] => state.cases.cases;

/**
 * This function is going to replace the targets only if they are not already set.
 */
export const getCasesWithTargetsIfNotSet = createSelector(
  [getCases, getTargetsById],
  (cases, targetsById) => {
    const clonedCases = cloneDeep(cases);
    clonedCases.forEach((caseEntry) => {

      caseEntry.targets = caseEntry.targets.filter(filterRepeatedTargets).map((target) => {
        if (target.caseId == null && target.id != null && targetsById[target.id] != null) {
          return targetsById[target.id];
        }

        if (
          target?.id &&
          targetsById?.[target.id] &&
          (target.primaryType === 'SIP-URI' || target.primaryType === 'SIP-URI-CUSTOM') &&
          (targetsById?.[target.id].primaryType === 'SIP-URI' || targetsById?.[target.id].primaryType === 'SIP-URI-CUSTOM')
        ) {
          return {
            ...target,
            primaryValue: targetsById?.[target.id].primaryValue,
          };
        }

        return target;
      });
    });

    return clonedCases;
  },
);

export const filterRepeatedTargets = (target: TargetModel, _index: number, targetList: TargetModel[]): boolean => {
  if (target.primaryType !== 'SIP-URI-CUSTOM') {
    return true;
  }

  return !targetList.some((item) =>
    item.primaryType === 'SIP-URI' &&
    item.primaryValue === target.primaryValue);
};
